export default __webpack_public_path__ + "static/media/elearn.89bbd195.PNG";